@if (isInitialized) {
  <oe-flat-widget [title]="component.alias" [modalComponent]="modalComponent"
    [icon]="{name: 'oe-grid-storage', color: 'dark'}">
    <!--Selected mode-->
    <oe-flat-widget-line [name]="'GENERAL.MODE' | translate" [value]="mode"
    [converter]="CONVERT_MODE_TO_MANUAL_OFF_AUTOMATIC"></oe-flat-widget-line>
    @if (mode !== 'OFF') {
      <!--SellToGridLimit - Grid feed in limitation is avoided-->
      @if (isSellToGridLimitAvoided) {
        <oe-flat-widget-line leftColumnWidth="20" [name]="'GENERAL.STATE' | translate"
          [value]="'EDGE.INDEX.WIDGETS.GRID_OPTIMIZED_CHARGE.STATE.GRID_FEED_IN_LIMITATION_IS_AVOIDED' | translate">
        </oe-flat-widget-line>
        <!--Minimum charge limit - negative are not shown-->
        @if (sellToGridLimitMinimumChargeLimit > 0) {
          <oe-flat-widget-line
            [name]="'EDGE.INDEX.WIDGETS.GRID_OPTIMIZED_CHARGE.MINIMUM_CHARGE'| translate"
            [converter]="CONVERT_WATT_TO_KILOWATT" [value]="sellToGridLimitMinimumChargeLimit">
          </oe-flat-widget-line>
        }
      } @else {
        <oe-flat-widget-line leftColumnWidth="20" [name]="'GENERAL.STATE' | translate" [value]="state">
        </oe-flat-widget-line>
        <!--DelayCharge maximum charge limit-->
        @if (delayChargeMaximumChargeLimit !== null) {
          <oe-flat-widget-line
            [name]="'EDGE.INDEX.WIDGETS.GRID_OPTIMIZED_CHARGE.MAXIMUM_CHARGE' | translate"
            [converter]="CONVERT_WATT_TO_KILOWATT" [value]="delayChargeMaximumChargeLimit">
          </oe-flat-widget-line>
        }
      }
      <!--DelayCharge State-->
    }
  </oe-flat-widget>
}
